import { fromUnixTime } from "date-fns/fromUnixTime";
import { XYDataType } from "@looksrare/uikit";
import { MoDHistoricalPrice } from "@looksrare/yolo-games-gql-typegen";

export const mapHistoricalPricesToTuple = (priceHistory: MoDHistoricalPrice[]): XYDataType => {
  return priceHistory.map(({ timestamp, price }) => {
    return [fromUnixTime(timestamp).getTime(), Number(price)];
  });
};
